import { SET_CALL_LOGS_FOR_USER } from 'redux/userCallLogs/userCallLogs.types';

const initState: any[] = [];

const userCallLogsReducer = (state = initState, action: any) => {
  switch (action.type) {
    case SET_CALL_LOGS_FOR_USER:
      return action.payload;
    default:
      return state;
  }
};

export default userCallLogsReducer;
